import { render, staticRenderFns } from "./ShopFriends.vue?vue&type=template&id=53d39446&"
import script from "./ShopFriends.vue?vue&type=script&lang=js&"
export * from "./ShopFriends.vue?vue&type=script&lang=js&"
import style0 from "./ShopFriends.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports